/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Product_Type_Goi_12_5gInputs */

const vi_shop_product_type_goi_12_5g = /** @type {(inputs: Shop_Product_Type_Goi_12_5gInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói 12,5g`)
};

/**

* @param {Shop_Product_Type_Goi_12_5gInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_product_type_goi_12_5g = /** @type {((inputs?: Shop_Product_Type_Goi_12_5gInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Product_Type_Goi_12_5gInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_product_type_goi_12_5g(inputs)
});